import "../services.css"
import "../servicescovers.css"

import { useState, useRef, useEffect } from "react";
import R from "../../../assets/Images/Quote/Hero-Section.jpg"
import { HelmetProvider } from 'react-helmet-async';
import Arrow from "../../../assets/Images/Elements/Arrow_O1.svg"

import Header from "../../../assets/components/01_header/header"
import Footer from "../../../assets/components/02_footer/footer"
import QuotationComponent from "../../../assets/components/06_quotation_component/quotation_component"
import test from "../../../assets/Images/Elements/M-Orange.svg"

export default function SEO() {
    const [stepT, setStepT] = useState(1);
    const TOTAL_SLIDES = 8;

    const selectorRef = useRef(null);
    const itemRefs = useRef([]);

    const autoSlideRef = useRef(null);
    const pauseTimeoutRef = useRef(null);

    const scrollToItem = (index) => {
        const item = itemRefs.current[index];
        const container = selectorRef.current;

        if (!item || !container) return;

        const itemLeft = item.offsetLeft;
        const containerWidth = container.offsetWidth;
        const itemWidth = item.offsetWidth;

        container.scrollTo({
            left: itemLeft - containerWidth / 2 + itemWidth / 2,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        startAutoSlide();
        return stopAutoSlide;
    }, []);

    const startAutoSlide = () => {
        stopAutoSlide();
        autoSlideRef.current = setInterval(() => {
            setStepT(prev => (prev === TOTAL_SLIDES ? 1 : prev + 1));
        }, 5000);
    };

    const stopAutoSlide = () => {
        if (autoSlideRef.current) {
            clearInterval(autoSlideRef.current);
            autoSlideRef.current = null;
        }
    };

    const pauseAutoSlide = () => {
        stopAutoSlide();

        if (pauseTimeoutRef.current) {
            clearTimeout(pauseTimeoutRef.current);
        }

        pauseTimeoutRef.current = setTimeout(() => {
            startAutoSlide();
        }, 4000);
    };

    useEffect(() => {
        scrollToItem(stepT - 1);
    }, [stepT]);

    return (
        <div>
            <HelmetProvider>
                <title>Expert SEO and Digital Marketing Services in Mumbai</title>
                <meta name="Adstrate is a digital marketing agency in Mumbai offering SEO, social media marketing in Mumbai, Instagram marketing agency services, and content creation for business growth." />
                <link rel="canonical" href="https://adstrate.in/services/search-engine-optimization" />
            </HelmetProvider>
            <Header />
            <div className="ServicesDetails-HeroSection ServicesDetails-HeroSection-Website">
                <div className="ServicesDetails-HeroSection-Glass">
                    <h1>Professional SEO Services</h1>
                    <p>As a results-driven digital marketing agency in Mumbai, Adstrate provides expert SEO services designed to improve search visibility, attract qualified traffic, and boost conversions.</p>
                    <a href="/quotation">
                        <p className="LinkLabel">Get Quote</p>
                        <img src={Arrow}/>
                    </a>
                </div>
            </div>
            <div className="ServicesPages-Services-Main">
                <div className="ServicesPages-Services-Info">
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 1 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>SEO Audit & Analysis</h2>
                            <p>
                                Comprehensive website and SEO audits to identify technical issues, content gaps, and opportunities for growth.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 2 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Keyword Research & Strategy</h2>
                            <p>
                                In-depth keyword research, competitor analysis, and search intent mapping for high-impact opportunities. 
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 3 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>On-Page SEO Optimization</h2>
                            <p>
                                Optimizing meta tags, headings, URL structure, internal linking, and page content for target keywords.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 4 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Technical SEO Fixes</h2>
                            <p>
                                Website speed optimization, mobile responsiveness, crawlability, schema markup, and security improvements.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 5 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Content Optimization & Creation</h2>
                            <p>
                                Aligning existing and new content with SEO goals, including blog posts, landing pages, and multimedia content.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 6 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Local SEO Setup</h2>
                            <p>
                                Google My Business optimization, citation building, local keyword targeting, and review management.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 7 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Performance Monitoring & Reporting</h2>
                            <p>
                               Tracking search rankings, traffic insights, conversion metrics, and providing actionable reports.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 8 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>SEO Maintenance & Recommendations</h2>
                            <p>
                                Continuous monitoring, refinement, and offboarding guidance for long-term SEO success.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ServicesPages-Services-Selector" ref={selectorRef}>
                    <div className="ServicesPages-Services-Selector-Selection">
                        {[
                        "SEO Audit & Analysis",
                        "Keyword Research & Strategy",
                        "On-Page SEO Optimization",
                        "Technical SEO Fixes",
                        "Content Optimization & Creation",
                        "Local SEO Setup",
                        "Performance Monitoring & Reporting",
                        "SEO Maintenance & Recommendations",

                        ].map((text, index) => (
                        <div
                            key={index}
                            ref={(el) => (itemRefs.current[index] = el)}
                            className={stepT === index + 1 ? "ServicesPages-Services-Selector-Card Home-active MicroLinksText" : "ServicesPages-Services-Selector-Card"}
                            onClick={() => {
                                pauseAutoSlide();
                                setStepT(index + 1);
                                scrollToItem(index);
                            }}
                        >
                            <div className="ServicesPages-Services-Selector-selection"></div>
                            <div className="ServicesPages-Services-Selector-hover"></div>
                            <p>{text}</p>
                        </div>
                        ))}
                    </div>
                </div>
            </div>
            <QuotationComponent />
            <Footer />
        </div>
    );
}